export default __webpack_public_path__ + "static/edpro-23a8b87aad8a134e9a25ab8cb661b131.png";